<template>
  <div
    ref="headerRef"
    class="border-primary fixed left-0 right-0 top-0 z-20 border-b-8 bg-white transition-transform duration-300 ease-in-out"
    :class="{ '-translate-y-full': isHidden }"
  >
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted, provide } from 'vue';

const isHidden = ref(false);
const headerRef = ref<HTMLElement | null>(null);
const isMenuOpen = ref(false);
let lastScrollY = 0;
const SCROLL_THRESHOLD = 10;
const HIDE_AFTER = 420;

const handleScroll = () => {
  const currentScrollY = window.scrollY;

  // Close menu when scrolling
  if (isMenuOpen.value) {
    isMenuOpen.value = false;
  }

  if (currentScrollY <= 0) {
    isHidden.value = false;
    lastScrollY = currentScrollY;
    return;
  }

  if (Math.abs(currentScrollY - lastScrollY) < SCROLL_THRESHOLD) {
    return;
  }

  isHidden.value = currentScrollY > lastScrollY && currentScrollY > HIDE_AFTER;
  lastScrollY = currentScrollY;
};

const handleClickOutside = (event: MouseEvent) => {
  if (!isMenuOpen.value) return;

  const target = event.target as HTMLElement;
  // Check if click is inside the header
  if (headerRef.value && !headerRef.value.contains(target)) {
    isMenuOpen.value = false;
  }
};

// Provide the menu state to child components
provide('menuState', {
  isMenuOpen,
  setMenuOpen: (value: boolean) => {
    isMenuOpen.value = value;
  },
});

onMounted(() => {
  window.addEventListener('scroll', handleScroll, { passive: true });
  document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
  document.removeEventListener('click', handleClickOutside);
});
</script>
